import { render, staticRenderFns } from "./mArtshare.vue?vue&type=template&id=0f8ad624&scoped=true"
import script from "./mArtshare.vue?vue&type=script&lang=js"
export * from "./mArtshare.vue?vue&type=script&lang=js"
import style0 from "./mArtshare.vue?vue&type=style&index=0&id=0f8ad624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ad624",
  null
  
)

export default component.exports